export var itPrSkip = function (title, fn) {
    if (process.env.agentType === 'pullrequest') {
        console.log("SKIPPING IN PR:", title);
        it.skip(title, fn);
    }
    else {
        it(title, fn);
    }
};
export var describePrSkip = function (title, fn) {
    if (process.env.agentType === 'pullrequest') {
        console.log("SKIPPING IN PR:", title);
        describe.skip(title, fn);
    }
    else {
        describe(title, fn);
    }
};
//# sourceMappingURL=skip-pr.js.map